var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.productArray.length != 0
    ? _c("div", { staticClass: "productsOuterWrapper" }, [
        _c("br"),
        _c("hr"),
        _c(
          "div",
          { staticClass: "productsInnerWrapper" },
          _vm._l(_vm.productArray, function(product) {
            return _c(
              "div",
              { key: product.productID, staticClass: "product" },
              [
                _c(
                  "a",
                  {
                    attrs: { href: _vm.basedir + "/" + product.productPageLink }
                  },
                  [
                    _c("img", { attrs: { src: product.imageUrl } }),
                    _c("div", { staticClass: "productName" }, [
                      _c("p", { domProps: { innerHTML: _vm._s(product.name) } })
                    ])
                  ]
                )
              ]
            )
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }